// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__feAUV","mainContent":"Layout_mainContent__8BhXB"};